import styles from "./federal-income-tax.module.css"

import React from "react"
import * as util from "activities/util"
import * as shared from "activities/components/shared"
import * as callouts from "activities/components/callouts"
import {Label, InputNoFocus, InputSection, RadioMenu, RadioOption} from "shared/components/inputs"
import * as fonts from "shared/fonts"
import * as tax from "story/util/tax-finance"

const calculateTaxes = (income, filingStatus) => {
  const withholdingAmount = tax.getTaxWithholding(filingStatus, income)
  return {
    percent: withholdingAmount / income || 0,
    dollarAmount: Math.max(withholdingAmount)
  }
}

export default shared.ActivityFactory(
  ({getState, getProps, updateState}) => {
    const {filingStatus, income = 0, resetKey} = getState()
    const {id} = getProps()
    const {percent, dollarAmount} = calculateTaxes(income, filingStatus)
    return (
      <div className={styles["wrapper"]}>
        <shared.Content className={styles["content"]}>
          <InputSection>
            <Label font={fonts.getFontClass()}>How will you file?</Label>
            <RadioMenu onChange={updateState("filingStatus")} value={filingStatus}>
              <RadioOption value="single" font={fonts.getFontClass()}>
                Single
              </RadioOption>
              <RadioOption value="head-of-household" font={fonts.getFontClass()}>
                Head of Household
              </RadioOption>
              <RadioOption value="married-jointly" font={fonts.getFontClass()}>
                Married, Jointly
              </RadioOption>
              <RadioOption value="married-separately" font={fonts.getFontClass()}>
                Married, Separately
              </RadioOption>
            </RadioMenu>
          </InputSection>
          <InputSection>
            <Label>What is your gross annual income?</Label>
            <InputNoFocus id={id} onChange={updateState("income", util.fromString)} value={income} resetKey={resetKey} />
          </InputSection>
        </shared.Content>
        <div className={styles["results"]}>
          <callouts.Callout calloutStyles={styles["callouts"]}>
            <callouts.Detail
              label="Percent Withheld for Federal Income Taxes"
              result={util.formatPercent(percent)}
              statStyles={styles["stat"]}
              labelStyles={styles["label"]}
              resultStyles={styles["result"]}
            />
            <callouts.Detail
              label="Monthly Amount Withheld"
              result={util.formatDollarsNoCents(dollarAmount / 12)}
              statStyles={styles["stat"]}
              labelStyles={styles["label"]}
              resultStyles={styles["result"]}
            />
          </callouts.Callout>
        </div>
      </div>
    )
  },
  {
    stateFilter: (state) => {
      const {income, filingStatus} = state
      return Object.assign(state, calculateTaxes(income, filingStatus))
    },
    defaultProps: {
      id: "federal-income-tax",
      className: "federal-income-tax",
      title: "Federal Income Tax Withholdings Calculator",
      subtitle:
        "Federal Income Taxes are withheld from your paycheck by your employer. To find how much, choose which filing status best describes your situation and enter your gross annual income (your income before taxes)."
    },
    defaultState: {
      filingStatus: "single",
      income: 50000
    }
  }
)
